import Model from './Model'
export default class ExpenseItem extends Model {

    resource()
    {
        return 'expense_items'
    }
}
